const isMobileRegex = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/i;

function useMobile() {
  const isMobile = isMobileRegex.test(navigator.userAgent);

  return isMobile;
}

export default useMobile;
